import React from "react";
import { Link } from "react-router-dom";
import { Milk, Mail, MapPin } from "lucide-react";
import { cn } from "@/lib/utils";

export const FOOTER_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy", test: "footer-privacy" },
  { to: "/terms", label: "Terms & Conditions", test: "footer-terms" },
  { to: "/refunds", label: "Cancellation & Refunds", test: "footer-refunds" },
  { to: "/shipping", label: "Shipping / Digital Delivery", test: "footer-shipping" },
  { to: "/contact", label: "Contact Us", test: "footer-contact" },
];

export default function Footer({ className }) {
  return (
    <footer data-testid="site-footer" className={cn("border-t bg-card/60", className)}>
      <div className="mx-auto w-full max-w-6xl px-4 py-8 sm:px-6 sm:py-10">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Brand */}
          <div className="space-y-3">
            <div className="flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                <Milk className="h-5 w-5" strokeWidth={2} />
              </div>
              <span className="font-heading text-base font-bold">Dairy Hub ERP</span>
            </div>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Dairy management software to help businesses manage dairy operations,
              records, users, and subscriptions.
            </p>
          </div>

          {/* Legal links */}
          <div className="space-y-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Legal</p>
            <ul className="flex flex-col gap-2">
              {FOOTER_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={l.test}
                    className="text-sm text-muted-foreground transition-colors hover:text-primary hover:underline"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Contact</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <a href="mailto:support@dairyhuberp.com" className="hover:text-primary hover:underline">
                  support@dairyhuberp.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span>At Post Andhari, Tq. Sillod, Dist. Sambhajinagar, Maharashtra, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Dairy Hub ERP. All rights reserved.</p>
          <p>Owned &amp; operated by Sunil Gangadhar Kamble.</p>
        </div>
      </div>
    </footer>
  );
}
